define('views/annotations/form',[
  "globals",
  "../abstract-comments/create-form"
], function (globals, AbstractCommentFormView) {
  "use strict";

  return AbstractCommentFormView.extend({});
});

